module.exports = __webpack_public_path__ + "img/flecha-der.f1057077.png";